
export const AUTH_TAGS = {
    GET_ME: "GetMe",
} as const;